import React, { useEffect } from "react";
import { Table } from "antd";
import { useAppModel } from "../appModel";
import { ColumnsType } from "antd/es/table";
import { IMdApp } from "../appService";

const columns: ColumnsType<IMdApp> = [

    {
        align: "center",
        title: '分支',
        width: 200,
        dataIndex: 'branch',
    },
    {
        align: "center",
        title: '编码',
        width: 200,
        dataIndex: 'code',
    },
    {
        align: "center",
        title: '名称',
        width: 320,
        dataIndex: 'name',
    },
    {
        align: "center",
        title: '状态',
        dataIndex: 'status',
        width: 120,
        render: (v) => v === 0 ? "正常" : "异常"
    },
    {
        align: "center",
        title: '备注',
        dataIndex: 'note',
    },
    {
        align: "center",
        title: '版本',
        width: 120,
        dataIndex: 'branch',
    },
    {
        align: "center",
        title: '禁用',
        width: 120,
        dataIndex: 'enable',
        render: v => v === 1 ? "否" : "是"
    },
];

export function DataTable() {
    const {
        dataSource, selectedRowKeys, pgCfg,
        loadData, setSelectedRowKeys
    } = useAppModel();


    return (
        <Table
            rowSelection={{
                type: "radio",
                onChange: (selectedRowKeys: React.Key[], selectedRows: IMdApp[]) => {
                    setSelectedRowKeys(selectedRowKeys);
                },
                selectedRowKeys
            }}
            columns={columns}
            dataSource={dataSource}
            pagination={{
                ...pgCfg,
                showTotal: (total: number) => `共${total}条`,
                position: ["bottomCenter"],
                onChange: (pageNum, pageSize) => {
                    loadData({ pageNum, pageSize }).then();
                }
            }}
            onRow={record => {
                return {
                    onClick: event => {
                        if (selectedRowKeys.length > 0 && selectedRowKeys[0] === record.key) {
                            setSelectedRowKeys([]);
                        } else {
                            setSelectedRowKeys([record.key]);
                        }
                    },
                };
            }}
        />
    )
}
